(function ($, Promise) {

		// Constructor
		function SkillGamesGame1(renderer, parent) {

			this.parent = parent;

			this.currentLevel = -1;
			this.currentSublevel = -1;
			this.currentTries = 0;
			this.startTime = 0;
			this.answers = [];
			this.slots = [];

			this.playerInteractionAllowed = false;
			this.currentInteraction = 0;
			this.multipurposeTimer = false;

			this.timerUpdateInterval = false;

			this.tl = false;

			this.cards = [
				{
					name: "drone-blue",
					texture: false,
				}, {
					name: "drone-green",
					texture: false
				}, {
					name: "drone-red",
					texture: false
				}, {
					name: "heli-blue",
					texture: false,
				}, {
					name: "heli-green",
					texture: false
				}, {
					name: "heli-red",
					texture: false
				}, {
					name: "hot-blue",
					texture: false,
				}, {
					name: "hot-green",
					texture: false
				}, {
					name: "hot-red",
					texture: false
				}, {
					name: "plane-blue",
					texture: false,
				}, {
					name: "plane-green",
					texture: false
				}, {
					name: "plane-red",
					texture: false
				}, {
					name: "hydra-blue",
					texture: false,
				}, {
					name: "hydra-green",
					texture: false
				}, {
					name: "hydra-red",
					texture: false
				}, {
					name: "zeplin-blue",
					texture: false,
				}, {
					name: "zeplin-green",
					texture: false
				}, {
					name: "zeplin-red",
					texture: false
				}
			];

			this.levels = [
				{
					name: "1",
					duration: 30000,
					tries: 3,
					layout: {
						rows: 1,
						columns: 3,
						slot_width: 480,
						slot_height: 396,
						card_scale: 0.6,
						padding: 80,
					},
					cards_group: [
						["drone-blue", "heli-green", "plane-red"],
						["drone-red", "heli-blue", "plane-green"],
						["drone-green", "heli-red", "plane-blue"],
					],
					sublevels: [
						{
							name: "1-1",
							cards_count: 2,
						},
						{
							name: "1-2",
							cards_count: 3,
						},
						{
							name: "1-3",
							cards_count: 4,
						},
						{
							name: "1-4",
							cards_count: 5,
						}
					]
				},
				{
					name: "2",
					duration: 30000,
					tries: 3,
					layout: {
						rows: 1,
						columns: 4,
						slot_width: 380,
						slot_height: 380,
						card_scale: 0.5,
						padding: 40,
					},
					cards_group: [
						["drone-blue", "heli-green", "plane-red", "hot-red"],
						["drone-red", "heli-blue", "plane-green", "hot-red"],
						["drone-green", "heli-red", "plane-blue", "hot-green"],
						["drone-green", "heli-green", "plane-red", "hot-blue"],
					],
					sublevels: [
						{
							name: "2-1",
							cards_count: 3,
						},
						{
							name: "2-2",
							cards_count: 4,
						},
						{
							name: "2-3",
							cards_count: 5,
						},
						{
							name: "2-4",
							cards_count: 6,
						}
					]
				},
				{
					name: "3",
					duration: 30000,
					tries: 3,
					layout: {
						rows: 2,
						columns: 3,
						slot_width: 380,
						slot_height: 380,
						card_scale: 0.5,
						padding: 50,
					},
					cards_group: [
						["drone-blue", "heli-green", "plane-green", "hot-red", "hydra-red", "zeplin-blue"],
						["drone-red", "heli-blue", "plane-green", "plane-red", "hydra-red", "zeplin-blue"],
						["drone-red", "heli-blue", "plane-blue", "hot-green", "hydra-green", "zeplin-red"],
						["drone-green", "heli-red", "plane-red", "hot-green", "hydra-blue", "zeplin-blue"],
					],
					sublevels: [
						{
							name: "3-1",
							cards_count: 4,
						},
						{
							name: "3-2",
							cards_count: 5,
						},
						{
							name: "3-3",
							cards_count: 6,
						},
						{
							name: "3-4",
							cards_count: 7,
						}
					]
				}
			];

			this.bgTexture = PIXI.Texture.from('images/skill_games/bg-2.png');
			this.frameTexture = PIXI.Texture.from('images/skill_games/memory/card-frame.png');

			this.state = false;
			this.renderer = renderer;
			this.stage = new PIXI.Container();
			this.ticker = new PIXI.Ticker();

			// Add background
			var bgSprite = new PIXI.Sprite(this.bgTexture);
			bgSprite.width = 1920;
			bgSprite.height = 1080;
			this.stage.addChild(bgSprite);

			// Create a container
			this.container = new PIXI.Container();
			this.stage.addChild(this.container);

			// Load cards textures
			for (var i = 0; i < this.cards.length; i++) {
				this.cards[i].texture = PIXI.Texture.from('images/skill_games/memory/cards/' + this.cards[i].name + ".png");
			}

			// Move container to the center
			this.container.x = 1920 / 2;
			this.container.y = 1080 / 2 + 50;

			// Center bunny sprite in local container coordinates
			this.container.pivot.x = this.container.width / 2;
			this.container.pivot.y = this.container.height / 2;

			// Listen for animate update
			this.ticker.add($.proxy(this.draw, this));

		}

		SkillGamesGame1.prototype.start = function () {
			this.state = true;
			this.ticker.start();
			this.startLevel(0, 0);
			// this.startLevel(1, 0);
			// this.startLevel(2, 0);
		}

		SkillGamesGame1.prototype.stop = function () {
			this.ticker.stop();
			this.clearTimerUpdate();
			this.state = false;
		}

		SkillGamesGame1.prototype.draw = function (delta) {
			// rotate the container!
			// use delta to create frame-independent transform
			// this.container.rotation += 0.01 * delta;

			// Trigger rendering
			this.renderer.render(this.stage);
		}

		SkillGamesGame1.prototype.startLevel = function (level, sublevel) {

			// Save current values values
			var previousLevel = this.currentLevel;
			var previousSubevel = this.currentSublevel;

			// Reset values
			this.currentInteraction = 0;
			this.currentLevel = level;
			this.currentSublevel = sublevel;
			this.startTime = millis();
			this.updateTopBar();
			this.timerUpdate(this.levels[this.currentLevel].duration);

			// For new levels
			if (previousLevel != level) {
				this.buildLevel();
			}

			// For new subevels
			if (previousLevel != level || previousSubevel != sublevel) {

				// Define correct answers
				var totalCards = this.levels[this.currentLevel].layout.columns * this.levels[this.currentLevel].layout.rows;
				var totalAnswers = this.levels[this.currentLevel].sublevels[this.currentSublevel].cards_count;

				// The folloiwng code reuse the previous cards to build up a sequence
				// for (var i = (this.answers.length - 1); i < totalAnswers; i++) {
				// 	this.answers.push(getRandomInt(0, totalCards - 1));
				// }

				// The folloiwng code rebuild a full sequence
				this.answers = [];
				for (var i = 0; i < totalAnswers; i++) {
					// var pickedAnswer = getRandomInt(0, totalCards - 1);

					// The following code make sure that two sequentials cards are not the same
					var pickedAnswer = getRandomInt(0, totalCards - 1);
					while ((this.answers.length > 0) && (pickedAnswer == this.answers[this.answers.length - 1])) {
						pickedAnswer = getRandomInt(0, totalCards - 1);
					}

					this.answers.push(pickedAnswer);
				}
			}


			// Animate sequence to replicate
			this.animateSequence()
		}

		SkillGamesGame1.prototype.buildLevel = function () {

			this.destroyLevel();

			var layoutData = this.levels[this.currentLevel].layout;

			// Select a cards group (and shuffle)
			var selectedCards = this.levels[this.currentLevel].cards_group[getRandomInt(0, this.levels[this.currentLevel].cards_group.length - 1)]
			selectedCards = shuffle(selectedCards);

			var index = 0;
			for (var j = 0; j < layoutData.rows; j++) {
				for (var i = 0; i < layoutData.columns; i++) {

					var slot = new PIXI.Container();
					slot.name = "slot-" + index;
					slot.x = i * layoutData.slot_width + (i * layoutData.padding) + (layoutData.slot_width / 2);
					slot.y = j * layoutData.slot_height + (j * layoutData.padding) + (layoutData.slot_height / 2);
					slot.interactive = true;
					slot.buttonMode = true;
					slot.off('pointertap').on('pointertap', $.proxy(this.validatePlayerInteraction, this));

					var frame = new PIXI.Sprite(this.frameTexture);
					frame.width = layoutData.slot_width;
					frame.height = layoutData.slot_height;
					frame.anchor.set(0.5);
					slot.addChild(frame);

					var card = new PIXI.Sprite(this.findCardByName([selectedCards[index]]).texture);
					card.name = "card-" + index;
					card.scale.set(layoutData.card_scale);
					card.anchor.set(0.5);
					card.alpha = 0;
					slot.addChild(card);

					this.container.addChild(slot);
					this.container.pivot.x = this.container.width / 2;
					this.container.pivot.y = this.container.height / 2;

					this.slots[index] = slot;

					index++;
				}
			}

			// Clear answers
			this.answers = [];
		}

		SkillGamesGame1.prototype.animateSequence = function () {

			this.tl = new TimelineMax({
				delay: 0.75,
			});

			for (var i = 0; i < this.answers.length; i++) {
				this.tl.to(this.slots[this.answers[i]].getChildAt(1), 0.5, {
					alpha: 1,
				});
				this.tl.to(this.slots[this.answers[i]].getChildAt(1), 0.5, {
					alpha: 0,
				}, "+=0.2");
			}
			this.tl.addCallback(this.yourTurn, "+=0.01", [], this);
		}

		SkillGamesGame1.prototype.yourTurn = function () {
			this.parent.showFeedback("your-turn");
			this.multipurposeTimer = setTimeout($.proxy(function () {
				this.parent.closeFeedback();
				this.allowPlayerInteraction();
			}, this), 2000);
		}

		SkillGamesGame1.prototype.allowPlayerInteraction = function () {
			console.log("allowPlayerInteraction")
			this.playerInteractionAllowed = true;
		}

		SkillGamesGame1.prototype.validatePlayerInteraction = function (e) {

			if (this.playerInteractionAllowed == false) {
				return;
			}

			// Define clicked element
			var selectedSlotName = e.currentTarget.name
			var selectedSlotId = parseInt(selectedSlotName.replace("slot-", ""));

			// Handle wrong answer
			if (this.answers[this.currentInteraction] != selectedSlotId) {
				this.playerInteractionAllowed = false;
				this.currentTries++;

				if (this.currentTries < 3) {
					// Wong answer
					console.log("wrong answer");
					this.parent.showFeedback("try-again");
					this.multipurposeTimer = setTimeout($.proxy(function () {
						this.parent.closeFeedback();
						this.startLevel(this.currentLevel, this.currentSublevel);
					}, this), 3000);
				} else {
					// Gameover
					console.log("gameover");
					$("#game-feedback-gameover .level-reached").text((this.currentLevel + 1))
					$("#game-trigger-1").addClass("failed");
					this.parent.showFeedback("gameover");
				}

				return;
			}

			// Animate in
			this.tl = new TimelineMax();
			this.tl.to(e.currentTarget.getChildAt(1), 0.5, {
				alpha: 1,
			});
			this.tl.to(e.currentTarget.getChildAt(1), 0.5, {
				alpha: 0,
			});

			// Good Answer
			this.currentInteraction++;
			console.log("good answer");

			if (this.currentInteraction >= this.answers.length) {
				this.playerInteractionAllowed = false;
				var nextSublevel = (this.currentSublevel + 1);
				var isLastLevel = (this.currentLevel + 1 >= this.levels.length);
				var isLastSubLevel = (nextSublevel >= this.levels[this.currentLevel].sublevels.length);

				this.multipurposeTimer = setTimeout($.proxy(function () {

					if (!isLastLevel || (isLastLevel && !isLastSubLevel)) {

						this.parent.showFeedback("good-work");

						this.multipurposeTimer = setTimeout($.proxy(function () {
							this.parent.closeFeedback();

							if (!isLastSubLevel) {
								// Start next sublevel
								console.log("Start next sublevel");
								this.startLevel(this.currentLevel, nextSublevel);

							} else if (!isLastLevel) {
								// Start next level
								console.log("Start next level");
								this.startLevel(this.currentLevel + 1, 0);

							} else {
								console.log("SHOULD NOT BE HERE : Game fully completed");
							}

						}, this), 2000);

					} else {

						// Game fully completed
						console.log("Game fully completed");
						$("#game-feedback-completed .level-reached").html((this.currentLevel + 1));
						$("#game-trigger-1").addClass("completed")
						this.parent.showFeedback("completed");
					}

				}, this), 500);
			}

		}

		SkillGamesGame1.prototype.destroyLevel = function () {
			for (var i = this.slots.length - 1; i >= 0; i--) {

				for (var i2 = this.slots[i].children.length - 1; i2 >= 0; i2--) {
					this.slots[i].children[i2].destroy();
				}

				this.container.removeChild(this.slots[i]);
				this.slots[i].destroy();
				this.slots.pop();
			}
		}

		SkillGamesGame1.prototype.findCardByName = function (name) {
			for (var i = 0; i < this.cards.length; i++) {
				if (this.cards[i].name == name) {
					return this.cards[i]
				}
			}
			return false;
		}

		SkillGamesGame1.prototype.timerUpdate = function (duration) {

			// Set inital text
			$("#game-top-bar #game-top-bar-timer .time-left").text(duration / 1000);

			// Start timer
			this.clearTimerUpdate();
			this.timerUpdateInterval = setInterval($.proxy(function (duration) {
				var timeleft = constrain(Math.ceil((duration - (millis() - this.startTime)) / 1000), 0, duration / 1000);
				$("#game-top-bar #game-top-bar-timer .time-left").text(timeleft);
			}, this, duration), 1000);
		}

		SkillGamesGame1.prototype.updateTopBar = function () {
			$("#game-top-bar").addClass("no-timer no-score").removeClass("no-tries");
			$("#game-top-bar .current-level").text(this.levels[this.currentLevel].name + "-" + (this.currentSublevel + 1))
			$("#game-top-bar .current-try").text(this.currentTries + 1);
			$("#game-top-bar .tries-total").text(this.levels[this.currentLevel].tries);
		}

		SkillGamesGame1.prototype.clearTimerUpdate = function () {
			if (this.timerUpdateInterval != false) {
				clearInterval(this.timerUpdateInterval);
				this.timerUpdateInterval = false;
			}
		}

		SkillGamesGame1.prototype.clearMultipurposeTimer = function () {
			if (this.multipurposeTimer != false) {
				clearInterval(this.multipurposeTimer);
				this.multipurposeTimer = false;
			}
		}

		SkillGamesGame1.prototype.reset = function () {
			this.playerInteractionAllowed = false;
			this.destroyLevel();
			this.clearMultipurposeTimer();
			this.clearTimerUpdate();

			this.currentLevel = -1;
			this.currentSublevel = -1;
			this.currentTries = 0;
			this.startTime = 0;
			this.answers = [];
			this.slots = [];

			if(this.tl != false) {
				this.tl.kill();
				this.tl = false;
			}
		}

		// Expose SkillGamesGame1
		window.SkillGamesGame1 = SkillGamesGame1;
	}
)
(jQuery, Promise);
